export enum TockProductType {
  EVENTS = 'EVENTS',
  CLASSIC = 'CLASSIC',
}
export const EVENTS_PRODUCT_TYPE = TockProductType.EVENTS as TockProductType.EVENTS;
export const CLASSIC_PRODUCT_TYPE = TockProductType.CLASSIC as TockProductType.CLASSIC;

export enum TockClassicProductLevel {
  INTRO = 'INTRO',
  PLUS = 'PLUS',
  PRO = 'PRO',
}

export enum TockEventsProductLevel {
  ESSENTIAL = 'ESSENTIAL',
  PREMIUM = 'PREMIUM',

  ESSENTIAL_DEPRECATED = 'ESSENTIAL_DEPRECATED',
  PREMIUM_DEPRECATED = 'PREMIUM_DEPRECATED',
}

// This is a funny way to get both a type and value enum that is the union
// of the two enums above.
export const TockProductLevel = Object.assign({}, TockClassicProductLevel, TockEventsProductLevel);
export type TockProductLevel = TockEventsProductLevel | TockClassicProductLevel;

export const TockProductLevelValue: { [key in TockProductLevel]: number } = {
  // Classic Product Plans
  [TockClassicProductLevel.INTRO]: 1,
  [TockClassicProductLevel.PLUS]: 2,
  [TockClassicProductLevel.PRO]: 3,

  // Events Product Plans
  [TockEventsProductLevel.ESSENTIAL]: 1,
  [TockEventsProductLevel.ESSENTIAL_DEPRECATED]: 1,
  [TockEventsProductLevel.PREMIUM]: 2,
  [TockEventsProductLevel.PREMIUM_DEPRECATED]: 2,
};

/**
 * An enum-ified version of core.SubscriptionAddonType.
 */
// As core.SubscriptionAddonType changes, keep this enum in sync.
export enum TockSubscriptionAddon {
  SMS_WAITLIST = 'SMS_WAITLIST',
}
